/**
 * Date-interval tokens of the ELP filter overlay, mirroring the backend's
 * lenient `datePreset` tokens exactly (`EventDatePresets.cs`).
 */
export type EventDatePresetToken =
  | 'today'
  | 'tomorrow'
  | 'thisWeek'
  | 'nextWeek'
  | 'everyday'
  | 'mondayToFriday'
  | 'weekend'
  | 'sunday';

/**
 * Render order for the filter overlay's 2-column checkbox grid — row-major,
 * matching the Figma layout (col 1: Today/Tomorrow/This week/Next week,
 * col 2: Everyday/Monday-Friday/Every Weekend/Every Sunday).
 */
export const EVENT_DATE_PRESET_ORDER: EventDatePresetToken[] = [
  'today',
  'everyday',
  'tomorrow',
  'mondayToFriday',
  'thisWeek',
  'weekend',
  'nextWeek',
  'sunday',
];
